import Document from '@tiptap/extension-document'

export const DocumentWithoutTitle = Document.extend({
  content: 'block+',
})
